/**
 * 接続元アクセス制御に関する UI 文言定数
 *
 * 【表記ゆれ禁止】download/upload/バナーのすべての表示箇所はここからのみ参照すること。
 * 文言を変更する場合は必ずこのファイルのみを修正し、各コンポーネントには直書きしない。
 *
 * 設計書 §2.9 (UX R5) / 仕様書 §2.9 参照。
 */

/** ダウンロードボタンの非活性理由・403 レスポンス時の専用文言 */
export const DOWNLOAD_INTERNAL_ONLY =
  'ダウンロードは院内ネットワークからのみ可能です';

/** アップロード導線の非活性理由・送信拒否時の専用文言 */
export const UPLOAD_INTERNAL_ONLY =
  'アップロードは院内ネットワークからのみ可能です';

/** 資料（PDF）の「元のファイルを保存」ボタンの非活性理由・403レスポンス時の専用文言 */
export const MATERIAL_DOWNLOAD_INTERNAL_ONLY =
  '資料の原本保存は院内ネットワークからのみ可能です';

/** 資料（PDF）の追加・削除の非活性理由・403レスポンス時の専用文言（動画アップロードと同じ扱い） */
export const MATERIAL_UPLOAD_INTERNAL_ONLY =
  '資料の追加・削除は院内ネットワークからのみ可能です';

/**
 * 処理中（変換中／アップロード中）動画の削除ボタンの非活性理由・403 レスポンス時の専用文言
 *
 * 処理中動画の削除は DELETE /api/videos/upload/:sessionId を叩き、
 * backend では upload 系として requireInternalNetwork('upload') が掛かっている。
 * 変換完了済みの通常動画の削除（DELETE /api/videos）は院外でも許可されているため、
 * この文言を出してよいのは処理中動画のみ。
 */
export const PROCESSING_DELETE_INTERNAL_ONLY =
  '変換中の動画の削除は院内ネットワークからのみ可能です';

/**
 * 遠隔接続中を示すページ上部バナー文言
 * isExternal===true の場合のみ表示し、院内では非表示にすること。
 */
export const REMOTE_BANNER =
  '現在 院外ネットワークで接続中。ダウンロード・アップロードは院内のみ利用できます';

/**
 * 診療科未設定の動画で、ケバブメニューの公開系項目（院内公開にする／外部公開にする）
 * の非活性理由・ホバー/フォーカス時の専用文言。
 *
 * サーバー側の必須化チェック（PUBLISH_REQUIRES_SPECIALTY_MESSAGE, videoController.ts）
 * の手前で画面側が案内するものであり、サーバー側チェックの代替ではない。
 * 「非公開にする」は対象外（公開を止める操作は塞がない）。
 */
export const PUBLISH_REQUIRES_SPECIALTY =
  '診療科を設定してください';
